var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-view'),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"routerView"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"routerView"}):_vm._e(),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }